type IntradayBidTag = {
  tag_id: string
  display_name: string
  enabled?: boolean
  buy: Record<string, unknown>
  sell: Record<string, unknown>
  metadata?: Record<string, unknown>
}

export function matchesActiveSubtype(tag: IntradayBidTag, activeSubtype: string): boolean {
  if (!activeSubtype) {
    return true
  }

  const subtype = tag.metadata?.['subtype']
  if (typeof subtype !== 'string') {
    return true
  }

  return subtype === activeSubtype
}
